import {OrderDepthExpansionModel} from "../../models/OrderDepthExpansionModel";

export interface OrderDepthStoreExpansionToggle {
    readonly side: ToggleSide;
    readonly row: number;
}

export enum ToggleSide {
    BID,
    ASK
}

export function bidDepthToggle(row: number): OrderDepthStoreExpansionToggle {
    return depthToggle(ToggleSide.BID, row);
}

export function askDepthToggle(row: number): OrderDepthStoreExpansionToggle {
    return depthToggle(ToggleSide.ASK, row);
}

function depthToggle(side: ToggleSide, row: number): OrderDepthStoreExpansionToggle {
    return {
        side,
        row
    };
}

export function applyToggle(model: OrderDepthExpansionModel,
                            toggle: OrderDepthStoreExpansionToggle): OrderDepthExpansionModel {
    if (toggle.side === ToggleSide.BID) {
        return model.toggleBidPrice(toggle.row);
    } else if (toggle.side === ToggleSide.ASK) {
        return model.toggleAskPrice(toggle.row);
    } else {
        console.warn(`Unhandled Toggle Side ${toggle.side}`);
        return model;
    }
}
